var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLokalizacja(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lokalizacja",
    transform: "translate(-184.67 -370.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    d: "M9.128,0H30.872A9.129,9.129,0,0,1,40,9.129V30.872A9.129,9.129,0,0,1,30.872,40H9.128A9.128,9.128,0,0,1,0,30.872V9.128A9.128,9.128,0,0,1,9.128,0Z",
    transform: "translate(184.67 370.276)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(194.744 377.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M203.678,376.547a9.925,9.925,0,0,0-9.925,9.925c0,5.481,9.925,16.164,9.925,16.164s9.925-10.683,9.925-16.164A9.925,9.925,0,0,0,203.678,376.547Zm0,13.381A3.932,3.932,0,1,1,207.611,386,3.933,3.933,0,0,1,203.678,389.928Z",
    transform: "translate(-193.753 -376.547)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLokalizacja);
export default __webpack_public_path__ + "static/media/lokalizacja.6574a85bd5064cb349c77a244cabb873.svg";
export { ForwardRef as ReactComponent };